module.exports = __webpack_public_path__ + "static/media/web_small_banner.434fd742.jpg";